export default {
    page_title: "Tasks",
    add_button: "Add",
    created_tasks: "Created Tasks",
    completed_tasks: "Completed Tasks",
    on_time_tasks: "Completed On Time",
    conversions: "Conversions",
    conversion_rate: "Conversion Rate",
    incentivized_revenue: "Incentivized Revenue",
    by_user: "By User",
    by_automation: "By Automation",
    name: "Name",
    created: "Created",
    completed: "Completed",
    on_time: "Completed On Time",
    no_data_for_period: "No data for selected period",
    automation_filter: "Automation",
    task_due_date: "Task due date",
    created_date: "Creation date",
    completed_date: "Completion date",
};
